export default __webpack_public_path__ + "static/media/detail_big_16_6.5331b0f2.jpg";